document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('.pe-event-date-trigger[data-popup]');
    if (triggers.length === 0) {
        return;
    }

    const openModals = new Set();

    const openModal = (modal, trigger) => {
        modal.classList.remove('kd-popup-invisible');
        modal.classList.add('kd-popup-visible');
        // The shared kd-popup-wrapper/kd-popup__bg classes are also picked up by the
        // site-wide popup.js, whose bg-click handler sets an inline `visibility: hidden`
        // (delayed 200ms) that only its own .kd-play-video open flow ever clears. Since our
        // trigger isn't a .kd-play-video, undo that leftover inline style ourselves.
        modal.style.removeProperty('visibility');
        modal.dataset.openedBy = trigger.dataset.popup;
        openModals.add(modal);
        const panel = modal.querySelector('.pe-event-date-modal');
        if (panel) {
            panel.focus();
        }
    };

    const closeModal = (modal, trigger) => {
        modal.classList.remove('kd-popup-visible');
        modal.classList.add('kd-popup-invisible');
        openModals.delete(modal);
        if (trigger) {
            trigger.focus();
        }
    };

    triggers.forEach((trigger) => {
        const id = trigger.dataset.popup;
        if (!id) {
            return;
        }
        const modal = document.getElementById(id);
        if (!modal) {
            return;
        }

        // Move the modal to the end of <body> so it escapes any ancestor's stacking
        // context (e.g. an Okvir section's .inner-container is position:relative;z-index:1),
        // matching how the site-wide popup already renders outside all content wrappers.
        document.body.appendChild(modal);

        trigger.addEventListener('click', () => openModal(modal, trigger));

        const bg = modal.querySelector('.kd-popup__bg');
        const closeButton = modal.querySelector('.pe-event-date-modal__close');

        [bg, closeButton].forEach((closeEl) => {
            if (!closeEl) {
                return;
            }
            closeEl.addEventListener('click', () => closeModal(modal, trigger));
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || openModals.size === 0) {
            return;
        }
        openModals.forEach((modal) => {
            const trigger = document.querySelector(
                '.pe-event-date-trigger[data-popup="' + modal.dataset.openedBy + '"]'
            );
            closeModal(modal, trigger);
        });
    });
});
